import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Service, HttpMethod } from '../../../domain/model/common/service.class';
import { VerificationSummaryModel, VerificationDetailsModel } from '../model/verification.model';

@Injectable()
export class VerificationService extends Service {
    private _verificationUrl: string;
    private _verificationPanelOpen: boolean = false;
    private _extraParam: string | undefined;
    private _reverifying: boolean = false;
    private _secondPathFragment: string | undefined;
    private _thirdPathFragment: string | undefined;
    public configChanges: Subject<any>;

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, '');
        this.configChanges = new Subject();
    }

    setUrl(url: string, extraParam?: string, secondPathFragment?: string, thirdPathFragment?: string): void {
        this._verificationUrl = url;
        this._extraParam = extraParam;
        this._secondPathFragment = secondPathFragment;
        this._thirdPathFragment = thirdPathFragment;
        this.configChanges.next();
    }

    getUrl(): string {
        return `${this._verificationUrl}/currentUser${
                this._secondPathFragment ? `/${this._secondPathFragment}` : ''
            }${
                this._thirdPathFragment ? `/${this._thirdPathFragment}` : ''
            }?verify=true${
                this._extraParam ? `&${this._extraParam}` : ''
            }`;
    }

    compareUrl(url: string): boolean {
        return this._verificationUrl === url;
    }

    setPanelStatus(status: boolean): void {
        this._verificationPanelOpen = status;
    }

    getPanelStatus(): boolean {
        return this._verificationPanelOpen;
    }

    setReverifying(status: boolean): void {
        this._reverifying = status;
    }

    getReverifyingStatus(): boolean {
        return this._reverifying;
    }

    postNotes(notes): Observable<any> {
        return this.call(this.getUrl(), undefined, notes, HttpMethod.POST, true);
    }

    getVerificationDetails(): Observable<VerificationDetailsModel> {
        return this.get(VerificationDetailsModel, this.getUrl());
    }

    getSummary(): Observable<VerificationSummaryModel> {
        return this.get(VerificationSummaryModel, 'verification/currentUser');
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/verification/service/verification.service.ts